<!--
  The HamburgerButton is a component designed to open/close the MobileNavigation.
  props:
    - menuOpen: Used to handle the menu state, used for accessibility properties
-->
<!-- eslint-disable max-len -->
<template>
  <button class="navbar-toggle collapsed" aria-label="Open the main menu">
    <slot></slot>
  </button>
</template>
<!-- eslint-enable max-len -->
<script>
export default {
  name: "hamburger-button",
  props: {
    menuOpen: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
